export default {
  props: ['id'],
  data() {
    return {
      instructionID: this.$props.id,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    instructions() {
      return this.$store.state.news.instructions;
    },
    instruction() {
      return this.$store.state.news.instruction;
    },
  },
  methods: {
    setInstructionReaded() {
      this.$store.dispatch('news/SetInstructionReaded', {
        profile_id: this.user.profile_id,
        instruction_id: +this.instructionID,
      });
    },
    async loadInstruction() {
      if (!this.instructions.length && this.user.profile_id) {
        await this.$store.dispatch('news/GetInstructions', this.user.profile_id);
      }
      await this.$store.dispatch('news/SetInstruction', +this.instructionID);
    },
  },
  created() {
    if (!this.user.profile_id || !this.instructionID) return;
    this.loadInstruction();
    this.setInstructionReaded();
  },
};
